// extracted by mini-css-extract-plugin
export default {"npnBanner":"styles_npnBanner__isfcq"};